import React from "react";
import { useState } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import MentalHealthQuiz from "../components/assessment/MentalHealthQuiz";
import AssessmentResults from "../components/assessment/AssessmentResults";

export type AssessmentResultType = {
  score: number;
  severityLevel: "minimal" | "mild" | "moderate" | "moderately severe" | "severe";
  recommendation: string;
};

const Assessment = () => {
  const [result, setResult] = useState<AssessmentResultType | null>(null);
  
  const handleQuizComplete = (assessmentResult: AssessmentResultType) => {
    setResult(assessmentResult);
    window.scrollTo(0, 0);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow py-12 bg-gradient-to-br from-violet-50 to-indigo-50">
        <div className="container px-4 md:px-6">
          <div className="max-w-3xl mx-auto">
            {!result ? (
              <MentalHealthQuiz onComplete={handleQuizComplete} />
            ) : (
              <AssessmentResults result={result} />
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Assessment;
